module.exports = __webpack_public_path__ + "d0034ccd577957505e7f84cd2264cfa7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/wizards-hut-main.png
// module id = 590
// module chunks = 0